module.exports = __webpack_public_path__ + "img/dr-andrew-laflin-mouw-family-chiropractic.f814ef0b.jpg";